// src/constants/errorCodes.ts
var ERROR_CODES = {
  // ═══════════════════════════════════════════════════════════════
  // 通用错误 G0xx
  // ═══════════════════════════════════════════════════════════════
  INTERNAL_ERROR: { code: "G000", httpStatus: 500, message: "\u670D\u52A1\u5668\u5185\u90E8\u9519\u8BEF" },
  SERVICE_UNAVAILABLE: { code: "G001", httpStatus: 503, message: "\u670D\u52A1\u6682\u65F6\u4E0D\u53EF\u7528" },
  RATE_LIMIT_EXCEEDED: { code: "G002", httpStatus: 429, message: "\u8BF7\u6C42\u8FC7\u4E8E\u9891\u7E41\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5" },
  INVALID_REQUEST: { code: "G003", httpStatus: 400, message: "\u65E0\u6548\u7684\u8BF7\u6C42" },
  FEATURE_DISABLED: { code: "G004", httpStatus: 403, message: "\u8BE5\u529F\u80FD\u5DF2\u7981\u7528" },
  // 通用验证 G1xx
  VALIDATION_ERROR: { code: "G100", httpStatus: 400, message: "\u53C2\u6570\u9A8C\u8BC1\u5931\u8D25" },
  MISSING_PARAMETER: { code: "G101", httpStatus: 400, message: "\u7F3A\u5C11\u5FC5\u8981\u53C2\u6570" },
  INVALID_PARAMETER: { code: "G102", httpStatus: 400, message: "\u53C2\u6570\u683C\u5F0F\u65E0\u6548" },
  PARAMETER_OUT_OF_RANGE: { code: "G103", httpStatus: 400, message: "\u53C2\u6570\u8D85\u51FA\u6709\u6548\u8303\u56F4" },
  // ═══════════════════════════════════════════════════════════════
  // 认证模块 A0xx-A5xx
  // ═══════════════════════════════════════════════════════════════
  UNAUTHORIZED: { code: "A000", httpStatus: 401, message: "\u672A\u6388\u6743\uFF0C\u8BF7\u5148\u767B\u5F55" },
  TOKEN_EXPIRED: { code: "A001", httpStatus: 401, message: "\u767B\u5F55\u5DF2\u8FC7\u671F\uFF0C\u8BF7\u91CD\u65B0\u767B\u5F55" },
  TOKEN_INVALID: { code: "A002", httpStatus: 401, message: "\u65E0\u6548\u7684\u767B\u5F55\u51ED\u8BC1" },
  TOKEN_MISSING: { code: "A003", httpStatus: 401, message: "\u7F3A\u5C11\u767B\u5F55\u51ED\u8BC1" },
  SESSION_EXPIRED: { code: "A004", httpStatus: 401, message: "\u4F1A\u8BDD\u5DF2\u8FC7\u671F" },
  SESSION_REVOKED: { code: "A005", httpStatus: 401, message: "\u4F1A\u8BDD\u5DF2\u88AB\u6CE8\u9500" },
  // 认证验证 A1xx
  INVALID_EMAIL: { code: "A100", httpStatus: 400, message: "\u90AE\u7BB1\u683C\u5F0F\u65E0\u6548" },
  INVALID_PASSWORD: { code: "A101", httpStatus: 400, message: "\u5BC6\u7801\u683C\u5F0F\u65E0\u6548" },
  PASSWORD_TOO_SHORT: { code: "A102", httpStatus: 400, message: "\u5BC6\u7801\u957F\u5EA6\u4E0D\u8DB3\uFF0C\u81F3\u5C11\u9700\u89816\u4F4D" },
  PASSWORD_TOO_WEAK: { code: "A103", httpStatus: 400, message: "\u5BC6\u7801\u5F3A\u5EA6\u4E0D\u8DB3" },
  INVALID_NAME: { code: "A104", httpStatus: 400, message: "\u7528\u6237\u540D\u683C\u5F0F\u65E0\u6548" },
  NAME_TOO_LONG: { code: "A105", httpStatus: 400, message: "\u7528\u6237\u540D\u8FC7\u957F" },
  // 认证权限 A2xx
  LOGIN_LOCKED: { code: "A200", httpStatus: 403, message: "\u8D26\u6237\u5DF2\u9501\u5B9A\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5" },
  DEVICE_LIMIT_EXCEEDED: { code: "A201", httpStatus: 403, message: "\u767B\u5F55\u8BBE\u5907\u6570\u91CF\u5DF2\u8FBE\u4E0A\u9650" },
  ACCOUNT_DISABLED: { code: "A202", httpStatus: 403, message: "\u8D26\u6237\u5DF2\u88AB\u7981\u7528" },
  ADMIN_REQUIRED: { code: "A203", httpStatus: 403, message: "\u9700\u8981\u7BA1\u7406\u5458\u6743\u9650" },
  // 认证状态 A4xx
  EMAIL_ALREADY_REGISTERED: { code: "A400", httpStatus: 409, message: "\u8BE5\u90AE\u7BB1\u5DF2\u88AB\u6CE8\u518C" },
  EMAIL_NOT_REGISTERED: { code: "A401", httpStatus: 404, message: "\u8BE5\u90AE\u7BB1\u672A\u6CE8\u518C" },
  WRONG_PASSWORD: { code: "A402", httpStatus: 401, message: "\u5BC6\u7801\u9519\u8BEF" },
  // ═══════════════════════════════════════════════════════════════
  // 文件模块 F0xx-F5xx
  // ═══════════════════════════════════════════════════════════════
  FILE_NOT_FOUND: { code: "F000", httpStatus: 404, message: "\u6587\u4EF6\u4E0D\u5B58\u5728" },
  FILE_TOO_LARGE: { code: "F001", httpStatus: 413, message: "\u6587\u4EF6\u5927\u5C0F\u8D85\u8FC7\u9650\u5236" },
  INVALID_FILE_TYPE: { code: "F002", httpStatus: 400, message: "\u4E0D\u652F\u6301\u7684\u6587\u4EF6\u7C7B\u578B" },
  FILE_CORRUPTED: { code: "F003", httpStatus: 400, message: "\u6587\u4EF6\u5DF2\u635F\u574F" },
  FILE_EMPTY: { code: "F004", httpStatus: 400, message: "\u6587\u4EF6\u5185\u5BB9\u4E3A\u7A7A" },
  FILE_UPLOAD_FAILED: { code: "F005", httpStatus: 500, message: "\u6587\u4EF6\u4E0A\u4F20\u5931\u8D25" },
  FILE_DOWNLOAD_FAILED: { code: "F006", httpStatus: 500, message: "\u6587\u4EF6\u4E0B\u8F7D\u5931\u8D25" },
  FILE_DELETE_FAILED: { code: "F007", httpStatus: 500, message: "\u6587\u4EF6\u5220\u9664\u5931\u8D25" },
  FILE_PREVIEW_NOT_SUPPORTED: { code: "F008", httpStatus: 400, message: "\u8BE5\u6587\u4EF6\u7C7B\u578B\u4E0D\u652F\u6301\u9884\u89C8" },
  FILE_CONTENT_NOT_FOUND: { code: "F009", httpStatus: 404, message: "\u6587\u4EF6\u5185\u5BB9\u4E0D\u5B58\u5728" },
  // 文件验证 F1xx
  INVALID_FILENAME: { code: "F100", httpStatus: 400, message: "\u6587\u4EF6\u540D\u65E0\u6548" },
  FILENAME_TOO_LONG: { code: "F101", httpStatus: 400, message: "\u6587\u4EF6\u540D\u8FC7\u957F" },
  INVALID_PATH: { code: "F102", httpStatus: 400, message: "\u6587\u4EF6\u8DEF\u5F84\u65E0\u6548" },
  FOLDER_NOT_FOUND: { code: "F103", httpStatus: 404, message: "\u6587\u4EF6\u5939\u4E0D\u5B58\u5728" },
  INVALID_MIME_TYPE: { code: "F104", httpStatus: 400, message: "MIME\u7C7B\u578B\u65E0\u6548" },
  MIME_TYPE_NOT_ALLOWED: { code: "F105", httpStatus: 400, message: "\u8BE5\u6587\u4EF6\u7C7B\u578B\u4E0D\u5141\u8BB8\u4E0A\u4F20\u5230\u6B64\u6587\u4EF6\u5939" },
  // 文件权限 F2xx
  FILE_ACCESS_DENIED: { code: "F200", httpStatus: 403, message: "\u65E0\u6743\u8BBF\u95EE\u6B64\u6587\u4EF6" },
  FILE_WRITE_DENIED: { code: "F201", httpStatus: 403, message: "\u65E0\u6743\u4FEE\u6539\u6B64\u6587\u4EF6" },
  FILE_DELETE_DENIED: { code: "F202", httpStatus: 403, message: "\u65E0\u6743\u5220\u9664\u6B64\u6587\u4EF6" },
  FILE_SHARE_DENIED: { code: "F203", httpStatus: 403, message: "\u65E0\u6743\u5206\u4EAB\u6B64\u6587\u4EF6" },
  FOLDER_ACCESS_DENIED: { code: "F204", httpStatus: 403, message: "\u65E0\u6743\u8BBF\u95EE\u6B64\u6587\u4EF6\u5939" },
  // 文件资源 F3xx
  FILE_IN_TRASH: { code: "F300", httpStatus: 400, message: "\u6587\u4EF6\u5DF2\u5728\u56DE\u6536\u7AD9" },
  FILE_NOT_IN_TRASH: { code: "F301", httpStatus: 400, message: "\u6587\u4EF6\u4E0D\u5728\u56DE\u6536\u7AD9\u4E2D" },
  FILE_ALREADY_RESTORED: { code: "F302", httpStatus: 400, message: "\u6587\u4EF6\u5DF2\u6062\u590D" },
  // 文件状态 F4xx
  FILE_ALREADY_EXISTS: { code: "F400", httpStatus: 409, message: "\u6587\u4EF6\u5DF2\u5B58\u5728" },
  FOLDER_ALREADY_EXISTS: { code: "F401", httpStatus: 409, message: "\u6587\u4EF6\u5939\u5DF2\u5B58\u5728" },
  FOLDER_NOT_EMPTY: { code: "F402", httpStatus: 400, message: "\u6587\u4EF6\u5939\u4E0D\u4E3A\u7A7A" },
  CANNOT_MOVE_TO_SELF: { code: "F403", httpStatus: 400, message: "\u4E0D\u80FD\u5C06\u6587\u4EF6\u79FB\u52A8\u5230\u81EA\u8EAB" },
  CANNOT_MOVE_TO_SUBFOLDER: { code: "F404", httpStatus: 400, message: "\u4E0D\u80FD\u5C06\u6587\u4EF6\u5939\u79FB\u52A8\u5230\u5176\u5B50\u6587\u4EF6\u5939\u4E2D" },
  CANNOT_DELETE_ROOT: { code: "F405", httpStatus: 400, message: "\u4E0D\u80FD\u5220\u9664\u6839\u76EE\u5F55" },
  // 存储相关 F5xx
  STORAGE_EXCEEDED: { code: "F500", httpStatus: 507, message: "\u5B58\u50A8\u7A7A\u95F4\u4E0D\u8DB3" },
  BUCKET_NOT_FOUND: { code: "F501", httpStatus: 404, message: "\u5B58\u50A8\u6876\u4E0D\u5B58\u5728" },
  BUCKET_CONNECTION_FAILED: { code: "F502", httpStatus: 502, message: "\u5B58\u50A8\u6876\u8FDE\u63A5\u5931\u8D25" },
  BUCKET_NOT_ACTIVE: { code: "F503", httpStatus: 400, message: "\u5B58\u50A8\u6876\u672A\u6FC0\u6D3B" },
  BUCKET_QUOTA_EXCEEDED: { code: "F504", httpStatus: 507, message: "\u5B58\u50A8\u6876\u914D\u989D\u5DF2\u6EE1" },
  NO_STORAGE_CONFIGURED: { code: "F505", httpStatus: 500, message: "\u672A\u914D\u7F6E\u5B58\u50A8\u6876" },
  PRESIGN_URL_FAILED: { code: "F506", httpStatus: 500, message: "\u751F\u6210\u9884\u7B7E\u540DURL\u5931\u8D25" },
  // ═══════════════════════════════════════════════════════════════
  // 分享模块 S0xx-S5xx
  // ═══════════════════════════════════════════════════════════════
  SHARE_NOT_FOUND: { code: "S000", httpStatus: 404, message: "\u5206\u4EAB\u94FE\u63A5\u4E0D\u5B58\u5728" },
  SHARE_EXPIRED: { code: "S001", httpStatus: 410, message: "\u5206\u4EAB\u94FE\u63A5\u5DF2\u8FC7\u671F" },
  SHARE_PASSWORD_REQUIRED: { code: "S002", httpStatus: 401, message: "\u9700\u8981\u8BBF\u95EE\u5BC6\u7801" },
  SHARE_PASSWORD_INVALID: { code: "S003", httpStatus: 401, message: "\u8BBF\u95EE\u5BC6\u7801\u9519\u8BEF" },
  SHARE_DOWNLOAD_LIMIT_EXCEEDED: { code: "S004", httpStatus: 403, message: "\u4E0B\u8F7D\u6B21\u6570\u5DF2\u8FBE\u4E0A\u9650" },
  SHARE_UPLOAD_LIMIT_EXCEEDED: { code: "S005", httpStatus: 403, message: "\u4E0A\u4F20\u6B21\u6570\u5DF2\u8FBE\u4E0A\u9650" },
  SHARE_FILE_NOT_FOUND: { code: "S006", httpStatus: 404, message: "\u5206\u4EAB\u7684\u6587\u4EF6\u4E0D\u5B58\u5728" },
  SHARE_FOLDER_NOT_FOUND: { code: "S007", httpStatus: 404, message: "\u5206\u4EAB\u7684\u6587\u4EF6\u5939\u4E0D\u5B58\u5728" },
  // 分享验证 S1xx
  INVALID_SHARE_ID: { code: "S100", httpStatus: 400, message: "\u65E0\u6548\u7684\u5206\u4EABID" },
  INVALID_UPLOAD_TOKEN: { code: "S101", httpStatus: 400, message: "\u65E0\u6548\u7684\u4E0A\u4F20\u4EE4\u724C" },
  // 分享权限 S2xx
  SHARE_CREATE_DENIED: { code: "S200", httpStatus: 403, message: "\u65E0\u6743\u521B\u5EFA\u5206\u4EAB" },
  SHARE_DELETE_DENIED: { code: "S201", httpStatus: 403, message: "\u65E0\u6743\u5220\u9664\u6B64\u5206\u4EAB" },
  UPLOAD_LINK_NOT_ALLOWED: { code: "S202", httpStatus: 400, message: "\u6B64\u5206\u4EAB\u4E0D\u652F\u6301\u4E0A\u4F20" },
  DOWNLOAD_NOT_ALLOWED: { code: "S203", httpStatus: 400, message: "\u6B64\u5206\u4EAB\u4E0D\u652F\u6301\u4E0B\u8F7D" },
  // 分享状态 S4xx
  SHARE_ALREADY_EXISTS: { code: "S400", httpStatus: 409, message: "\u5206\u4EAB\u5DF2\u5B58\u5728" },
  UPLOAD_LINK_IS_DOWNLOAD: { code: "S401", httpStatus: 400, message: "\u6B64\u94FE\u63A5\u4E3A\u4E0A\u4F20\u94FE\u63A5\uFF0C\u4E0D\u53EF\u4E0B\u8F7D" },
  DOWNLOAD_LINK_IS_UPLOAD: { code: "S402", httpStatus: 400, message: "\u6B64\u94FE\u63A5\u4E3A\u4E0B\u8F7D\u94FE\u63A5\uFF0C\u4E0D\u53EF\u4E0A\u4F20" },
  // ═══════════════════════════════════════════════════════════════
  // 存储桶模块 B0xx-B5xx
  // ═══════════════════════════════════════════════════════════════
  BUCKET_CREATE_FAILED: { code: "B000", httpStatus: 500, message: "\u521B\u5EFA\u5B58\u50A8\u6876\u5931\u8D25" },
  BUCKET_UPDATE_FAILED: { code: "B001", httpStatus: 500, message: "\u66F4\u65B0\u5B58\u50A8\u6876\u5931\u8D25" },
  BUCKET_DELETE_FAILED: { code: "B002", httpStatus: 500, message: "\u5220\u9664\u5B58\u50A8\u6876\u5931\u8D25" },
  BUCKET_TEST_FAILED: { code: "B003", httpStatus: 500, message: "\u5B58\u50A8\u6876\u8FDE\u63A5\u6D4B\u8BD5\u5931\u8D25" },
  BUCKET_MIGRATE_FAILED: { code: "B004", httpStatus: 500, message: "\u5B58\u50A8\u6876\u8FC1\u79FB\u5931\u8D25" },
  // 存储桶验证 B1xx
  INVALID_BUCKET_NAME: { code: "B100", httpStatus: 400, message: "\u5B58\u50A8\u6876\u540D\u79F0\u65E0\u6548" },
  INVALID_ENDPOINT: { code: "B101", httpStatus: 400, message: "\u7AEF\u70B9URL\u65E0\u6548" },
  INVALID_ACCESS_KEY: { code: "B102", httpStatus: 400, message: "\u8BBF\u95EE\u5BC6\u94A5\u65E0\u6548" },
  INVALID_SECRET_KEY: { code: "B103", httpStatus: 400, message: "\u5BC6\u94A5\u65E0\u6548" },
  INVALID_PROVIDER: { code: "B104", httpStatus: 400, message: "\u4E0D\u652F\u6301\u7684\u5B58\u50A8\u63D0\u4F9B\u5546" },
  // 存储桶权限 B2xx
  BUCKET_ACCESS_DENIED: { code: "B200", httpStatus: 403, message: "\u65E0\u6743\u8BBF\u95EE\u6B64\u5B58\u50A8\u6876" },
  BUCKET_OWNER_REQUIRED: { code: "B201", httpStatus: 403, message: "\u9700\u8981\u5B58\u50A8\u6876\u6240\u6709\u8005\u6743\u9650" },
  // 存储桶状态 B4xx
  BUCKET_ALREADY_EXISTS: { code: "B400", httpStatus: 409, message: "\u5B58\u50A8\u6876\u5DF2\u5B58\u5728" },
  BUCKET_IN_USE: { code: "B401", httpStatus: 400, message: "\u5B58\u50A8\u6876\u6B63\u5728\u4F7F\u7528\u4E2D\uFF0C\u65E0\u6CD5\u5220\u9664" },
  DEFAULT_BUCKET_EXISTS: { code: "B402", httpStatus: 400, message: "\u5DF2\u5B58\u5728\u9ED8\u8BA4\u5B58\u50A8\u6876" },
  // ═══════════════════════════════════════════════════════════════
  // 用户模块 U0xx-U5xx
  // ═══════════════════════════════════════════════════════════════
  USER_NOT_FOUND: { code: "U000", httpStatus: 404, message: "\u7528\u6237\u4E0D\u5B58\u5728" },
  USER_CREATE_FAILED: { code: "U001", httpStatus: 500, message: "\u521B\u5EFA\u7528\u6237\u5931\u8D25" },
  USER_UPDATE_FAILED: { code: "U002", httpStatus: 500, message: "\u66F4\u65B0\u7528\u6237\u5931\u8D25" },
  USER_DELETE_FAILED: { code: "U003", httpStatus: 500, message: "\u5220\u9664\u7528\u6237\u5931\u8D25" },
  // 用户验证 U1xx
  INVALID_USER_ID: { code: "U100", httpStatus: 400, message: "\u7528\u6237ID\u65E0\u6548" },
  // 用户权限 U2xx
  USER_ACCESS_DENIED: { code: "U200", httpStatus: 403, message: "\u65E0\u6743\u8BBF\u95EE\u6B64\u7528\u6237\u4FE1\u606F" },
  CANNOT_DELETE_SELF: { code: "U201", httpStatus: 400, message: "\u4E0D\u80FD\u5220\u9664\u81EA\u5DF1\u7684\u8D26\u6237" },
  CANNOT_MODIFY_ADMIN: { code: "U202", httpStatus: 403, message: "\u4E0D\u80FD\u4FEE\u6539\u7BA1\u7406\u5458\u8D26\u6237" },
  // 用户状态 U4xx
  USER_ALREADY_EXISTS: { code: "U400", httpStatus: 409, message: "\u7528\u6237\u5DF2\u5B58\u5728" },
  // ═══════════════════════════════════════════════════════════════
  // 任务模块 T0xx-T5xx
  // ═══════════════════════════════════════════════════════════════
  TASK_NOT_FOUND: { code: "T000", httpStatus: 404, message: "\u4EFB\u52A1\u4E0D\u5B58\u5728" },
  TASK_EXPIRED: { code: "T001", httpStatus: 410, message: "\u4EFB\u52A1\u5DF2\u8FC7\u671F" },
  TASK_CREATE_FAILED: { code: "T002", httpStatus: 500, message: "\u521B\u5EFA\u4EFB\u52A1\u5931\u8D25" },
  TASK_CANCEL_FAILED: { code: "T003", httpStatus: 500, message: "\u53D6\u6D88\u4EFB\u52A1\u5931\u8D25" },
  TASK_RETRY_FAILED: { code: "T004", httpStatus: 500, message: "\u91CD\u8BD5\u4EFB\u52A1\u5931\u8D25" },
  // 任务验证 T1xx
  INVALID_URL: { code: "T100", httpStatus: 400, message: "URL\u683C\u5F0F\u65E0\u6548" },
  UNSUPPORTED_URL: { code: "T101", httpStatus: 400, message: "\u4E0D\u652F\u6301\u7684URL\u7C7B\u578B" },
  // 任务状态 T4xx
  TASK_ALREADY_RUNNING: { code: "T400", httpStatus: 409, message: "\u4EFB\u52A1\u6B63\u5728\u8FD0\u884C\u4E2D" },
  TASK_ALREADY_COMPLETED: { code: "T401", httpStatus: 400, message: "\u4EFB\u52A1\u5DF2\u5B8C\u6210" },
  TASK_ALREADY_CANCELLED: { code: "T402", httpStatus: 400, message: "\u4EFB\u52A1\u5DF2\u53D6\u6D88" },
  TASK_ALREADY_FAILED: { code: "T403", httpStatus: 400, message: "\u4EFB\u52A1\u5DF2\u5931\u8D25" },
  CANNOT_PAUSE_TASK: { code: "T404", httpStatus: 400, message: "\u65E0\u6CD5\u6682\u505C\u6B64\u4EFB\u52A1" },
  CANNOT_RESUME_TASK: { code: "T405", httpStatus: 400, message: "\u65E0\u6CD5\u6062\u590D\u6B64\u4EFB\u52A1" },
  CANNOT_RETRY_TASK: { code: "T406", httpStatus: 400, message: "\u53EA\u80FD\u91CD\u8BD5\u5931\u8D25\u7684\u4EFB\u52A1" },
  CANNOT_DELETE_RUNNING_TASK: { code: "T407", httpStatus: 400, message: "\u65E0\u6CD5\u5220\u9664\u6B63\u5728\u8FD0\u884C\u7684\u4EFB\u52A1" },
  // ═══════════════════════════════════════════════════════════════
  // 权限模块 P0xx-P5xx
  // ═══════════════════════════════════════════════════════════════
  PERMISSION_DENIED: { code: "P000", httpStatus: 403, message: "\u6743\u9650\u4E0D\u8DB3" },
  PERMISSION_NOT_FOUND: { code: "P001", httpStatus: 404, message: "\u6743\u9650\u8BB0\u5F55\u4E0D\u5B58\u5728" },
  PERMISSION_CREATE_FAILED: { code: "P002", httpStatus: 500, message: "\u521B\u5EFA\u6743\u9650\u5931\u8D25" },
  PERMISSION_DELETE_FAILED: { code: "P003", httpStatus: 500, message: "\u5220\u9664\u6743\u9650\u5931\u8D25" },
  // 权限验证 P1xx
  INVALID_PERMISSION_LEVEL: { code: "P100", httpStatus: 400, message: "\u65E0\u6548\u7684\u6743\u9650\u7EA7\u522B" },
  // 权限状态 P4xx
  PERMISSION_ALREADY_EXISTS: { code: "P400", httpStatus: 409, message: "\u6743\u9650\u5DF2\u5B58\u5728" },
  CANNOT_MODIFY_OWNER_PERMISSION: { code: "P401", httpStatus: 400, message: "\u4E0D\u80FD\u4FEE\u6539\u6240\u6709\u8005\u6743\u9650" },
  // ═══════════════════════════════════════════════════════════════
  // 版本控制模块 V0xx-V5xx
  // ═══════════════════════════════════════════════════════════════
  VERSION_NOT_FOUND: { code: "V000", httpStatus: 404, message: "\u7248\u672C\u4E0D\u5B58\u5728" },
  VERSION_CREATE_FAILED: { code: "V001", httpStatus: 500, message: "\u521B\u5EFA\u7248\u672C\u5931\u8D25" },
  VERSION_RESTORE_FAILED: { code: "V002", httpStatus: 500, message: "\u6062\u590D\u7248\u672C\u5931\u8D25" },
  VERSION_DELETE_FAILED: { code: "V003", httpStatus: 500, message: "\u5220\u9664\u7248\u672C\u5931\u8D25" },
  VERSION_DIFF_FAILED: { code: "V004", httpStatus: 500, message: "\u7248\u672C\u5BF9\u6BD4\u5931\u8D25" },
  // 版本验证 V1xx
  INVALID_VERSION_NUMBER: { code: "V100", httpStatus: 400, message: "\u65E0\u6548\u7684\u7248\u672C\u53F7" },
  VERSION_NOT_SUPPORTED: { code: "V101", httpStatus: 400, message: "\u6B64\u6587\u4EF6\u4E0D\u652F\u6301\u7248\u672C\u63A7\u5236" },
  FOLDER_VERSION_NOT_SUPPORTED: { code: "V102", httpStatus: 400, message: "\u6587\u4EF6\u5939\u4E0D\u652F\u6301\u7248\u672C\u63A7\u5236" },
  // 版本状态 V4xx
  VERSION_LIMIT_EXCEEDED: { code: "V400", httpStatus: 400, message: "\u7248\u672C\u6570\u91CF\u5DF2\u8FBE\u4E0A\u9650" },
  CANNOT_DELETE_CURRENT_VERSION: { code: "V401", httpStatus: 400, message: "\u4E0D\u80FD\u5220\u9664\u5F53\u524D\u7248\u672C" },
  // ═══════════════════════════════════════════════════════════════
  // AI 模块 I0xx-I5xx
  // ═══════════════════════════════════════════════════════════════
  AI_SERVICE_UNAVAILABLE: { code: "I000", httpStatus: 503, message: "AI\u670D\u52A1\u6682\u4E0D\u53EF\u7528" },
  AI_ANALYZE_FAILED: { code: "I001", httpStatus: 500, message: "AI\u5206\u6790\u5931\u8D25" },
  AI_OCR_FAILED: { code: "I002", httpStatus: 500, message: "OCR\u8BC6\u522B\u5931\u8D25" },
  AI_CLASSIFY_FAILED: { code: "I003", httpStatus: 500, message: "\u56FE\u50CF\u5206\u7C7B\u5931\u8D25" },
  // AI 验证 I1xx
  AI_NOT_SUPPORTED_FOR_FILE: { code: "I100", httpStatus: 400, message: "\u6B64\u6587\u4EF6\u7C7B\u578B\u4E0D\u652F\u6301AI\u5206\u6790" },
  AI_FILE_TOO_LARGE: { code: "I101", httpStatus: 400, message: "\u6587\u4EF6\u8FC7\u5927\uFF0C\u65E0\u6CD5\u8FDB\u884CAI\u5206\u6790" },
  AI_QUOTA_EXCEEDED: { code: "I102", httpStatus: 429, message: "AI\u8C03\u7528\u6B21\u6570\u5DF2\u8FBE\u4E0A\u9650" },
  // ═══════════════════════════════════════════════════════════════
  // Telegram 存储模块 TG0xx-TG5xx
  // ═══════════════════════════════════════════════════════════════
  TG_UPLOAD_FAILED: { code: "TG00", httpStatus: 502, message: "Telegram\u4E0A\u4F20\u5931\u8D25" },
  TG_DOWNLOAD_FAILED: { code: "TG01", httpStatus: 502, message: "Telegram\u4E0B\u8F7D\u5931\u8D25" },
  TG_DELETE_FAILED: { code: "TG02", httpStatus: 502, message: "Telegram\u5220\u9664\u5931\u8D25" },
  TG_REF_NOT_FOUND: { code: "TG03", httpStatus: 404, message: "Telegram\u6587\u4EF6\u5F15\u7528\u4E0D\u5B58\u5728" },
  TG_CONFIG_ERROR: { code: "TG04", httpStatus: 500, message: "Telegram\u914D\u7F6E\u9519\u8BEF" },
  TG_FILE_TOO_LARGE: { code: "TG05", httpStatus: 413, message: "\u6587\u4EF6\u8D85\u8FC7Telegram\u9650\u5236\uFF08\u6700\u59272GB\uFF09" },
  TG_CHUNKED_DOWNLOAD_FAILED: { code: "TG06", httpStatus: 502, message: "Telegram\u5206\u7247\u4E0B\u8F7D\u5931\u8D25" }
};
function getErrorInfo(code) {
  const info = ERROR_CODES[code];
  return info ?? ERROR_CODES.INTERNAL_ERROR;
}
function getErrorMessage(code) {
  const info = ERROR_CODES[code];
  const internalMsg = ERROR_CODES.INTERNAL_ERROR.message;
  return info?.message ?? internalMsg;
}
function getHttpStatus(code) {
  const info = ERROR_CODES[code];
  const internalStatus = ERROR_CODES.INTERNAL_ERROR.httpStatus;
  return info?.httpStatus ?? internalStatus;
}

// src/constants/previewTypes.ts
var IMAGE_MIME_PREFIX = "image/";
var VIDEO_MIME_PREFIX = "video/";
var AUDIO_MIME_PREFIX = "audio/";
var PDF_MIME_TYPE = "application/pdf";
var MARKDOWN_MIME_TYPE = "text/markdown";
var CSV_MIME_TYPE = "text/csv";
var TEXT_MIME_PREFIX = "text/";
var JSON_MIME_TYPE = "application/json";
var XML_MIME_TYPE = "application/xml";
var OFFICE_MIME_TYPES = {
  word: ["application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  excel: ["application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  powerpoint: [
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation"
  ]
};
var EPUB_MIME_TYPES = ["application/epub+zip", "application/epub", "application/x-epub+zip"];
var FONT_MIME_TYPES = ["font/ttf", "font/otf", "font/woff", "font/woff2"];
var ARCHIVE_PREVIEW_MIME_TYPES = [
  "application/zip",
  "application/x-zip-compressed",
  "application/x-zip"
];
var ALL_OFFICE_MIME_TYPES = [
  ...OFFICE_MIME_TYPES.word,
  ...OFFICE_MIME_TYPES.excel,
  ...OFFICE_MIME_TYPES.powerpoint
];
var PREVIEWABLE_MIME_TYPES = [
  IMAGE_MIME_PREFIX,
  VIDEO_MIME_PREFIX,
  AUDIO_MIME_PREFIX,
  PDF_MIME_TYPE,
  TEXT_MIME_PREFIX,
  JSON_MIME_TYPE,
  XML_MIME_TYPE,
  ...ALL_OFFICE_MIME_TYPES,
  ...EPUB_MIME_TYPES,
  ...FONT_MIME_TYPES,
  ...ARCHIVE_PREVIEW_MIME_TYPES
];
var EXTENSION_PREVIEW_MAP = {
  ".epub": "epub",
  ".ttf": "font",
  ".otf": "font",
  ".woff": "font",
  ".woff2": "font",
  ".zip": "archive",
  ".csv": "csv",
  ".md": "markdown",
  ".doc": "word",
  ".docx": "word",
  ".xls": "excel",
  ".xlsx": "excel",
  ".ppt": "powerpoint",
  ".pptx": "powerpoint"
};
function getPreviewTypeByExtension(fileName) {
  const ext = "." + (fileName.split(".").pop()?.toLowerCase() || "");
  return EXTENSION_PREVIEW_MAP[ext] || null;
}
function isPreviewableMimeType(mimeType, fileName) {
  if (!mimeType) {
    if (fileName) {
      const extType = getPreviewTypeByExtension(fileName);
      return extType !== null;
    }
    return false;
  }
  if (mimeType.startsWith(IMAGE_MIME_PREFIX)) return true;
  if (mimeType.startsWith(VIDEO_MIME_PREFIX)) return true;
  if (mimeType.startsWith(AUDIO_MIME_PREFIX)) return true;
  if (mimeType === PDF_MIME_TYPE) return true;
  if (mimeType.startsWith(TEXT_MIME_PREFIX)) return true;
  if (mimeType === JSON_MIME_TYPE) return true;
  if (mimeType === XML_MIME_TYPE) return true;
  if (ALL_OFFICE_MIME_TYPES.includes(mimeType)) return true;
  if (EPUB_MIME_TYPES.includes(mimeType)) return true;
  if (FONT_MIME_TYPES.includes(mimeType)) return true;
  if (ARCHIVE_PREVIEW_MIME_TYPES.includes(mimeType)) {
    if (fileName && fileName.toLowerCase().endsWith(".epub")) return true;
    return true;
  }
  return false;
}
function getPreviewType(mimeType, fileName) {
  if (!mimeType) {
    return getPreviewTypeByExtension(fileName) || "unknown";
  }
  if (mimeType.startsWith(IMAGE_MIME_PREFIX)) return "image";
  if (mimeType.startsWith(VIDEO_MIME_PREFIX)) return "video";
  if (mimeType.startsWith(AUDIO_MIME_PREFIX)) return "audio";
  if (mimeType === PDF_MIME_TYPE) return "pdf";
  if (mimeType === MARKDOWN_MIME_TYPE || fileName.endsWith(".md")) return "markdown";
  if (mimeType === CSV_MIME_TYPE || fileName.endsWith(".csv")) return "csv";
  if (mimeType.startsWith(TEXT_MIME_PREFIX)) return "text";
  if (mimeType === JSON_MIME_TYPE || mimeType === XML_MIME_TYPE) return "code";
  if (OFFICE_MIME_TYPES.word.includes(mimeType)) return "word";
  if (OFFICE_MIME_TYPES.excel.includes(mimeType)) return "excel";
  if (OFFICE_MIME_TYPES.powerpoint.includes(mimeType)) {
    return "powerpoint";
  }
  if (EPUB_MIME_TYPES.includes(mimeType)) return "epub";
  if (FONT_MIME_TYPES.includes(mimeType)) return "font";
  if (ARCHIVE_PREVIEW_MIME_TYPES.includes(mimeType)) {
    if (fileName.toLowerCase().endsWith(".epub")) return "epub";
    return "archive";
  }
  const extType = getPreviewTypeByExtension(fileName);
  if (extType) return extType;
  return "unknown";
}
var PREVIEW_DEPENDENCIES = {
  docx: "docx-preview",
  xlsx: "xlsx",
  markdown: "react-markdown, remark-gfm, rehype-highlight, remark-math, rehype-katex",
  code: "highlight.js",
  csv: "papaparse",
  archive: "jszip",
  epub: "jszip",
  font: "\u6D4F\u89C8\u5668\u539F\u751F FontFace API",
  powerpoint: "jszip"
};

// src/constants/index.ts
var MAX_FILE_SIZE = 5 * 1024 * 1024 * 1024;
var DEFAULT_STORAGE_QUOTA = 10 * 1024 * 1024 * 1024;
var ALLOWED_MIME_TYPES = {
  image: ["image/jpeg", "image/png", "image/gif", "image/webp", "image/svg+xml", "image/bmp", "image/tiff"],
  video: ["video/mp4", "video/webm", "video/ogg", "video/quicktime", "video/x-msvideo", "video/x-matroska"],
  audio: ["audio/mpeg", "audio/wav", "audio/ogg", "audio/aac", "audio/flac", "audio/x-m4a"],
  document: [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation"
  ],
  text: ["text/plain", "text/html", "text/css", "text/javascript", "text/markdown", "text/csv"],
  code: ["application/json", "application/xml", "application/x-yaml", "application/x-sh"],
  archive: [
    "application/zip",
    "application/x-rar-compressed",
    "application/x-7z-compressed",
    "application/x-tar",
    "application/gzip"
  ]
};
var FILE_TYPE_ICONS = {
  "image/": "image",
  "video/": "video",
  "audio/": "audio",
  "application/pdf": "pdf",
  "application/zip": "archive",
  "application/x-": "code",
  "text/": "text"
};
var JWT_EXPIRY = 7 * 24 * 60 * 60 * 1e3;
var WEBDAV_SESSION_EXPIRY = 30 * 24 * 60 * 60 * 1e3;
var SHARE_DEFAULT_EXPIRY = 7 * 24 * 60 * 60 * 1e3;
var UPLOAD_CHUNK_SIZE = 10 * 1024 * 1024;
var MULTIPART_THRESHOLD = 100 * 1024 * 1024;
var MAX_CONCURRENT_PARTS = 5;
var THUMBNAIL_SIZES = {
  small: 128,
  medium: 256,
  large: 512
};
var TRASH_RETENTION_DAYS = 30;
var LOGIN_MAX_ATTEMPTS = 5;
var LOGIN_LOCKOUT_DURATION = 15 * 60 * 1e3;
var DEVICE_SESSION_EXPIRY = 30 * 24 * 60 * 60 * 1e3;
var UPLOAD_TASK_EXPIRY = 24 * 60 * 60 * 1e3;
var CODE_HIGHLIGHT_EXTENSIONS = {
  ".js": "javascript",
  ".jsx": "javascript",
  ".ts": "typescript",
  ".tsx": "typescript",
  ".py": "python",
  ".rb": "ruby",
  ".go": "go",
  ".rs": "rust",
  ".java": "java",
  ".c": "c",
  ".cpp": "cpp",
  ".h": "c",
  ".hpp": "cpp",
  ".cs": "csharp",
  ".php": "php",
  ".swift": "swift",
  ".kt": "kotlin",
  ".scala": "scala",
  ".r": "r",
  ".sql": "sql",
  ".sh": "bash",
  ".bash": "bash",
  ".zsh": "bash",
  ".json": "json",
  ".xml": "xml",
  ".yaml": "yaml",
  ".yml": "yaml",
  ".toml": "toml",
  ".ini": "ini",
  ".md": "markdown",
  ".markdown": "markdown",
  ".html": "html",
  ".htm": "html",
  ".css": "css",
  ".scss": "scss",
  ".sass": "sass",
  ".less": "less",
  ".vue": "vue",
  ".svelte": "svelte"
};
var API_ROUTES = {
  AUTH: {
    REGISTER: "/api/auth/register",
    LOGIN: "/api/auth/login",
    LOGOUT: "/api/auth/logout",
    ME: "/api/auth/me",
    DEVICES: "/api/auth/devices",
    SESSIONS: "/api/auth/sessions"
  },
  FILES: {
    LIST: "/api/files",
    CREATE: "/api/files",
    GET: (id) => `/api/files/${id}`,
    UPDATE: (id) => `/api/files/${id}`,
    DELETE: (id) => `/api/files/${id}`,
    UPLOAD: "/api/files/upload",
    DOWNLOAD: (id) => `/api/files/${id}/download`,
    PREVIEW: (id) => `/api/files/${id}/preview`,
    BATCH: "/api/files/batch",
    SEARCH: "/api/files/search",
    TAGS: "/api/files/tags"
  },
  SHARE: {
    CREATE: "/api/share",
    GET: (id) => `/api/share/${id}`,
    DOWNLOAD: (id) => `/api/share/${id}/download`
  },
  TASKS: {
    UPLOAD: "/api/tasks/upload",
    DOWNLOAD: "/api/tasks/download"
  },
  WEBDAV: "/dav"
};
var AUDIT_ACTIONS = {
  USER_LOGIN: "user.login",
  USER_LOGOUT: "user.logout",
  USER_REGISTER: "user.register",
  USER_UPDATE: "user.update",
  USER_DELETE: "user.delete",
  FILE_UPLOAD: "file.upload",
  FILE_DOWNLOAD: "file.download",
  FILE_DELETE: "file.delete",
  FILE_MOVE: "file.move",
  FILE_RENAME: "file.rename",
  FOLDER_CREATE: "folder.create",
  SHARE_CREATE: "share.create",
  SHARE_ACCESS: "share.access",
  BUCKET_CREATE: "bucket.create",
  BUCKET_UPDATE: "bucket.update",
  BUCKET_DELETE: "bucket.delete",
  ADMIN_USER_UPDATE: "admin.user_update",
  ADMIN_CONFIG_CHANGE: "admin.config_change"
};
var TAG_COLORS = [
  "#ef4444",
  "#f97316",
  "#f59e0b",
  "#eab308",
  "#84cc16",
  "#22c55e",
  "#10b981",
  "#14b8a6",
  "#06b6d4",
  "#0ea5e9",
  "#3b82f6",
  "#6366f1",
  "#8b5cf6",
  "#a855f7",
  "#d946ef",
  "#ec4899",
  "#f43f5e"
];

// src/utils/mimeTypes.ts
var MIME_TYPE_MAP = {
  ".md": "text/markdown",
  ".markdown": "text/markdown",
  ".txt": "text/plain",
  ".html": "text/html",
  ".htm": "text/html",
  ".css": "text/css",
  ".js": "text/javascript",
  ".mjs": "text/javascript",
  ".json": "application/json",
  ".xml": "application/xml",
  ".yaml": "application/x-yaml",
  ".yml": "application/x-yaml",
  ".csv": "text/csv",
  ".tsv": "text/tab-separated-values",
  ".jpg": "image/jpeg",
  ".jpeg": "image/jpeg",
  ".png": "image/png",
  ".gif": "image/gif",
  ".webp": "image/webp",
  ".svg": "image/svg+xml",
  ".bmp": "image/bmp",
  ".ico": "image/x-icon",
  ".tiff": "image/tiff",
  ".tif": "image/tiff",
  ".avif": "image/avif",
  ".heic": "image/heic",
  ".heif": "image/heif",
  ".mp4": "video/mp4",
  ".m4v": "video/mp4",
  ".webm": "video/webm",
  ".ogv": "video/ogg",
  ".mov": "video/quicktime",
  ".avi": "video/x-msvideo",
  ".mkv": "video/x-matroska",
  ".wmv": "video/x-ms-wmv",
  ".flv": "video/x-flv",
  ".3gp": "video/3gpp",
  ".m2ts": "video/mp2t",
  ".mp3": "audio/mpeg",
  ".mpeg": "audio/mpeg",
  ".mpg": "audio/mpeg",
  ".wav": "audio/wav",
  ".wave": "audio/wav",
  ".ogg": "audio/ogg",
  ".oga": "audio/ogg",
  ".aac": "audio/aac",
  ".m4a": "audio/mp4",
  ".flac": "audio/flac",
  ".wma": "audio/x-ms-wma",
  ".aiff": "audio/aiff",
  ".aif": "audio/aiff",
  ".pdf": "application/pdf",
  ".doc": "application/msword",
  ".docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ".xls": "application/vnd.ms-excel",
  ".xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ".ppt": "application/vnd.ms-powerpoint",
  ".pptx": "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  ".odt": "application/vnd.oasis.opendocument.text",
  ".ods": "application/vnd.oasis.opendocument.spreadsheet",
  ".odp": "application/vnd.oasis.opendocument.presentation",
  ".rtf": "application/rtf",
  ".zip": "application/zip",
  ".rar": "application/x-rar-compressed",
  ".7z": "application/x-7z-compressed",
  ".tar": "application/x-tar",
  ".gz": "application/gzip",
  ".gzip": "application/gzip",
  ".bz2": "application/x-bzip2",
  ".xz": "application/x-xz",
  ".exe": "application/x-msdownload",
  ".msi": "application/x-msi",
  ".dmg": "application/x-apple-diskimage",
  ".pkg": "application/x-newton-compatible-pkg",
  ".deb": "application/vnd.debian.binary-package",
  ".rpm": "application/x-rpm",
  ".apk": "application/vnd.android.package-archive",
  ".ipa": "application/octet-stream",
  ".app": "application/octet-stream",
  ".appimage": "application/x-executable",
  ".sh": "application/x-sh",
  ".bash": "application/x-sh",
  ".zsh": "application/x-sh",
  ".py": "text/x-python",
  ".rb": "text/x-ruby",
  ".go": "text/x-go",
  ".rs": "text/x-rust",
  ".java": "text/x-java-source",
  ".c": "text/x-c",
  ".cpp": "text/x-c++",
  ".h": "text/x-c",
  ".hpp": "text/x-c++",
  ".cs": "text/x-csharp",
  ".php": "text/x-php",
  ".swift": "text/x-swift",
  ".kt": "text/x-kotlin",
  ".scala": "text/x-scala",
  ".r": "text/x-r",
  ".sql": "application/sql",
  ".ps1": "application/x-powershell",
  ".bat": "application/x-msdos-program",
  ".cmd": "application/x-msdos-program",
  ".ts": "application/typescript",
  ".tsx": "application/typescript",
  ".jsx": "application/javascript",
  ".vue": "text/x-vue",
  ".svelte": "text/x-svelte",
  ".scss": "text/x-scss",
  ".sass": "text/x-sass",
  ".less": "text/x-less",
  ".toml": "application/toml",
  ".ini": "text/plain",
  ".env": "text/plain",
  ".gitignore": "text/plain",
  ".dockerignore": "text/plain",
  ".editorconfig": "text/plain",
  ".woff": "font/woff",
  ".woff2": "font/woff2",
  ".ttf": "font/ttf",
  ".otf": "font/otf",
  ".eot": "application/vnd.ms-fontobject"
};
function getMimeTypeFromExtension(fileName) {
  const lastDot = fileName.lastIndexOf(".");
  if (lastDot === -1 || lastDot === fileName.length - 1) {
    return null;
  }
  const ext = fileName.slice(lastDot).toLowerCase();
  return MIME_TYPE_MAP[ext] || null;
}
function inferMimeType(fileName, providedMimeType) {
  if (providedMimeType && providedMimeType !== "application/octet-stream") {
    return providedMimeType;
  }
  const inferredType = getMimeTypeFromExtension(fileName);
  if (inferredType) {
    return inferredType;
  }
  return "application/octet-stream";
}
var INSTALLER_MIME_TYPES = [
  "application/x-msdownload",
  "application/x-msi",
  "application/x-apple-diskimage",
  "application/x-newton-compatible-pkg",
  "application/vnd.debian.binary-package",
  "application/x-rpm",
  "application/vnd.android.package-archive",
  "application/x-executable"
];
function isInstallerMimeType(mimeType) {
  if (!mimeType) return false;
  return INSTALLER_MIME_TYPES.includes(mimeType);
}
var INSTALLER_EXTENSIONS = [
  ".exe",
  ".msi",
  ".dmg",
  ".pkg",
  ".deb",
  ".rpm",
  ".apk",
  ".ipa",
  ".app",
  ".appimage"
];
function isInstallerExtension(fileName) {
  const lastDot = fileName.lastIndexOf(".");
  if (lastDot === -1) return false;
  const ext = fileName.slice(lastDot).toLowerCase();
  return INSTALLER_EXTENSIONS.includes(ext);
}
export {
  ALLOWED_MIME_TYPES,
  ALL_OFFICE_MIME_TYPES,
  API_ROUTES,
  ARCHIVE_PREVIEW_MIME_TYPES,
  AUDIO_MIME_PREFIX,
  AUDIT_ACTIONS,
  CODE_HIGHLIGHT_EXTENSIONS,
  CSV_MIME_TYPE,
  DEFAULT_STORAGE_QUOTA,
  DEVICE_SESSION_EXPIRY,
  EPUB_MIME_TYPES,
  ERROR_CODES,
  EXTENSION_PREVIEW_MAP,
  FILE_TYPE_ICONS,
  FONT_MIME_TYPES,
  IMAGE_MIME_PREFIX,
  INSTALLER_EXTENSIONS,
  INSTALLER_MIME_TYPES,
  JSON_MIME_TYPE,
  JWT_EXPIRY,
  LOGIN_LOCKOUT_DURATION,
  LOGIN_MAX_ATTEMPTS,
  MARKDOWN_MIME_TYPE,
  MAX_CONCURRENT_PARTS,
  MAX_FILE_SIZE,
  MIME_TYPE_MAP,
  MULTIPART_THRESHOLD,
  OFFICE_MIME_TYPES,
  PDF_MIME_TYPE,
  PREVIEWABLE_MIME_TYPES,
  PREVIEW_DEPENDENCIES,
  SHARE_DEFAULT_EXPIRY,
  TAG_COLORS,
  TEXT_MIME_PREFIX,
  THUMBNAIL_SIZES,
  TRASH_RETENTION_DAYS,
  UPLOAD_CHUNK_SIZE,
  UPLOAD_TASK_EXPIRY,
  VIDEO_MIME_PREFIX,
  WEBDAV_SESSION_EXPIRY,
  XML_MIME_TYPE,
  getErrorInfo,
  getErrorMessage,
  getHttpStatus,
  getMimeTypeFromExtension,
  getPreviewType,
  getPreviewTypeByExtension,
  inferMimeType,
  isInstallerExtension,
  isInstallerMimeType,
  isPreviewableMimeType
};
//# sourceMappingURL=index.js.map